import { MenuItemDef } from "ag-grid-community";
import { MenuProps } from "antd";
import { TFunction } from "i18next";
import { ReactNode } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { getFirstString, getShortcutText, optT } from "./util";

export interface IContextAction<T = unknown> {
  action: (options?: T) => void;
  disabled?: boolean;
  icon?: ReactNode;
  text?: string;
  textKey: string;
  tooltip?: string;
  tooltipKey?: string;
  shortcut?: ShortcutDef;
}

export type ModifierKeys = "alt" | "ctrl" | "shift";
export interface ShortcutDef {
  modifiers: ModifierKeys[];
  key: string;
}

export class ContextAction {
  public action: (options?: unknown) => void;
  public disabled?: boolean;
  public icon?: ReactNode;
  public text?: string;
  public textKey: string;
  public tooltip?: string;
  public tooltipKey?: string;
  public shortcut?: ShortcutDef;

  constructor(contextAction: IContextAction) {
    this.action = contextAction.action;
    this.disabled = contextAction.disabled;
    this.icon = contextAction.icon;
    this.text = contextAction.text;
    this.textKey = contextAction.textKey;
    this.tooltip = contextAction.tooltip;
    this.tooltipKey = contextAction.tooltipKey;
    this.shortcut = contextAction.shortcut;
  }
}


// ag-grid context menu
export const actionToAgGridMenuItem = (
  action: ContextAction,
  t: TFunction,
): MenuItemDef => ({
  action: action.action,
  disabled: action.disabled,
  icon: action.icon ? renderToStaticMarkup(action.icon) : undefined,
  name: getFirstString(action.text, t(action.textKey)) ?? "",
  tooltip: getFirstString(action.tooltip, optT(t, action.tooltipKey)),
  shortcut: action.shortcut ? getShortcutText(action.shortcut) : undefined,
});


// antd context menu
export type AntdMenuItem = NonNullable<MenuProps["items"]>[number];
export const actionToAntdMenuItem = (
  action: ContextAction,
  t: TFunction,
): AntdMenuItem => ({
  disabled: action.disabled,
  icon: action.icon,
  key: action.textKey,
  label: getFirstString(action.text, t(action.textKey)),
  title: getFirstString(action.tooltip, optT(t, action.tooltipKey)),
  extra: action.shortcut ? getShortcutText(action.shortcut) : undefined,
  onClick: ({ domEvent }) => {
    domEvent.stopPropagation();
    action.action();
  },
});
